export default __webpack_public_path__ + "static/media/CHAKB OFB.e1687228.jpg";